/**
 * SMS delivery metrics — migrated to typed `@tiaki/http-client` per ADR 113.
 */
import { client } from '../lib/http-client';
import type {
  DeliveryMetricsParams,
  DeliveryMetricsResponse,
} from '../types/deliveryMetrics';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export async function getDeliveryMetrics(
  params?: DeliveryMetricsParams,
): Promise<DeliveryMetricsResponse> {
  const result = await client.GET('/api/v2/delivery-metrics/', {
    params: { query: (params ?? {}) as never },
  });
  return unwrap(result) as unknown as DeliveryMetricsResponse;
}
